module.exports = __webpack_public_path__ + "img/hotel-20a.a74bcd83.jpeg";